import { mapGetters } from "vuex";

export default {
  props: {
    cardId: String
  },
  
  computed: {
    ...mapGetters(["decisionBranches"]),
    decisionBranchesByCurrentCardId() {
      let allcdb = this.decisionBranches.cardDecisionBranches;
      if (allcdb) {
        return allcdb.filter((item) => item.card == this.cardId);
      } else {
        return [];
      }
    },
    currentBranch() {
      return this.decisionBranchesByCurrentCardId.filter(
        (item) => item.id == this.branchId
      )[0];
      
    },
    branchDisplayName(){
      let branch = this.currentBranch;
      if(branch){
        var nameArr = [];
        do{
          nameArr.push(branch.name);
          branch = this.getBranchById(branch.category);
        }while(branch != null);
        return nameArr.reverse().join(" - ");
      }
    }
  },
  methods: {
   getBranchById(id){
    if(id){
      return this.decisionBranchesByCurrentCardId.filter(
        (item) => item.id == id
      )[0];
    }
    return null;
   },
    currentBranchContainsNestedBranch() {
      return this.decisionBranchesByCurrentCardId.some((branch) => branch.actionType === "BRANCH")
    },
    decisionBranchesChildrenByCategoryId(categoryId) {
      return this.decisionBranchesByCurrentCardId
        .filter((item) => item.category == categoryId)
        .sort((a, b) => a.ehOrder - b.ehOrder);
    },
  },
};
